import { fetchWithAuth, refreshAccessToken } from "../services/apiService";
import { normalizeLanguageCode } from "../utils/language";
import { API_ERROR_CODES, hasApiErrorCode } from "./errorCodes";

// Обновление языка
export const updatePreferredLanguage = async (language) => {
    return await fetchWithAuth("api/Auth/language", {
        method: "PATCH",
        body: JSON.stringify(normalizeLanguageCode(language)),
    });
};

// Получить текущего пользователя (или null, если не авторизован)
export const getCurrentUser = async () => {
  try {
    const user = await fetchWithAuth("api/Auth/me", { method: "GET" });
    return user; // уже распарсенный JSON
  } catch (err) {
    // Anonymous/expired sessions are identified by stable transport metadata.
    if (err?.status === 401 || hasApiErrorCode(err, API_ERROR_CODES.UNAUTHORIZED)) {
      return null;
    }
    throw err;
  }
};

// Обновление токена
export const refreshToken = async () => {
  return refreshAccessToken();
};
